import { ClienteUnidadeNegocioSearchNaturezaVenda } from '../natureza-venda';

export class ClienteUnidadeNegocioSearchMercado {
    id: number;
    createdAt: Date;
    idMercado: number;
    nomeMercado: string;
    situacaoMercado: number;
    naturezasVendas: ClienteUnidadeNegocioSearchNaturezaVenda[];

    constructor() {
        this.naturezasVendas = [];
    }
}
